import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
   Box,
   Tabs,
   Tab,
   Typography,
   Paper,
   CircularProgress,
   Grid,
   Card,
   CardContent,
} from '@mui/material'
import { useApi } from '../api'
import QRCode from 'react-qr-code'

function TabPanel(props) {
   const { children, value, index, ...other } = props

   return (
      <div
         role="tabpanel"
         hidden={value !== index}
         id={`exams-tabpanel-${index}`}
         aria-labelledby={`exams-tab-${index}`}
         {...other}
      >
         {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
      </div>
   )
}

TabPanel.propTypes = {
   children: PropTypes.node,
   index: PropTypes.number.isRequired,
   value: PropTypes.number.isRequired,
}

function a11yProps(index) {
   return {
      id: `exams-tab-${index}`,
      'aria-controls': `exams-tabpanel-${index}`,
   }
}

export default function ExamsTabsJson() {
   const [value, setValue] = useState(0)
   const [examsData, setExamsData] = useState(null)
   const [examParticipantsData, setExamParticipantsData] = useState(null)
   const [loading, setLoading] = useState(true)

   const { get } = useApi()
   useEffect(() => {
      setLoading(true)

      // Exams
      get('/exams')
         .then((res) => {
            setExamsData(res.data)
            fetchExamParticipants(res.data[0]?.id)
         })
         .catch((err) => {
            console.error('Error fetching exams:', err)
         })
         .finally(() => setLoading(false))
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   const fetchExamParticipants = (exam_id) => {
      // Exam Participants
      if (!exam_id) return null
      get('/exam_participants_by_exam_id?exam_id=' + exam_id)
         .then((res) => {
            setExamParticipantsData(res)
         })
         .catch((err) => {
            console.error('Error fetching exam participants:', err)
         })
         .finally(() => setLoading(false))
   }

   const handleChange = (event, newValue) => {
      setValue(newValue)
      console.log(newValue)
   }

   return (
      <Paper elevation={2} sx={{ width: '100%', bgcolor: 'background.paper' }}>
         {/* Tab indicator */}
         <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
               value={value}
               onChange={handleChange}
               variant="scrollable"
               scrollButtons="auto"
               aria-label="Exams tabs"
            >
               {examsData?.map((exam, index) => (
                  <Tab
                     key={exam.id || index}
                     onClick={() => fetchExamParticipants(exam.id)}
                     label={`${exam.grade_name} - ${exam.session_name}`}
                     {...a11yProps(index)}
                  />
               ))}
            </Tabs>
         </Box>

         {/* Tab contents */}
         <Box
            sx={{
               p: 3,
            }}
         >
            {loading ? (
               <CircularProgress />
            ) : (
               <>
                  <Grid container spacing={2}>
                     {examParticipantsData?.participants?.map(
                        (participant, index) => (
                           <Grid
                              size={{
                                 xs: 12,
                                 sm: 6,
                                 md: 3,
                              }}
                              key={participant.id || index}
                           >
                              <Card>
                                 <CardContent>
                                    <Box
                                       display="flex"
                                       flexDirection="column"
                                       alignItems="center"
                                       gap={1}
                                    >
                                       <Typography variant="h6">
                                          Kartu Peserta
                                       </Typography>
                                       <Typography variant="h6">
                                          Sumatif Tengah Semester STS
                                       </Typography>
                                       <QRCode
                                          value={
                                             window.location.origin +
                                             '/exam/registration?exam_id=' +
                                             participant.exam_id +
                                             '&exam_participant_id=' +
                                             participant.id
                                          }
                                          size={128}
                                       />
                                       <Typography variant="caption">
                                          {window.location.origin +
                                             '/exam/registration?exam_id=' +
                                             participant.exam_id +
                                             '&exam_participant_id=' +
                                             participant.id}
                                       </Typography>

                                       <Typography variant="h6">
                                          {participant.name}
                                       </Typography>
                                       <Typography variant="body1">
                                          {participant.is_registered
                                             ? 'Registered'
                                             : 'Not Registered Yet'}
                                       </Typography>
                                       <Typography variant="body2">
                                          {participant.registration_detail}
                                       </Typography>
                                    </Box>
                                 </CardContent>
                              </Card>
                           </Grid>
                        )
                     )}
                  </Grid>
               </>
            )}
         </Box>
      </Paper>
   )
}
